define([
	"dojo/_base/declare",
	"Sourcing/NewProductAlternativeBase",

	"Apparel/ProductAlternativeForm"
], function(declare,NewProductAlternativeBase) {

	return declare(NewProductAlternativeBase, {
		_getSpecURL: function() {
			return this.m_formData.getFieldValue("PASpec");
		}
	});
});